import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=c1bfdfd6&scoped=true"
import script from "./Partnership.vue?vue&type=script&lang=js"
export * from "./Partnership.vue?vue&type=script&lang=js"
import style0 from "./Partnership.vue?vue&type=style&index=0&id=c1bfdfd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bfdfd6",
  null
  
)

export default component.exports